import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

export default function JoinUs(){
    const { t } = useTranslation();

    const applyforjob = () => {
        const _url = 'https://sellagroup.wd3.myworkdayjobs.com/centricoindiaprivatelimited/job/Chennai-India/Evergreen-Requisition_JR-000451'
        window.open(_url, "_blank")
    }

    return(
        <article id="careers">
            <section className="joinus">
                <Container>
                    <Row>
                        <Col>
                            <div class="section-highlight">{t(`lifeatcentrico.joinus.title`)}</div>
                        </Col>
                    </Row>
                    <Row className="mt-5">
                        <Col md={12}>
                            <Row>
                                <Col md={6} className="mb-2">
                                    <div className="wrapper">
                                        <div className="job-details">
                                            <div className="jd-info">
                                                <div className="title">Digital Engineers</div>
                                                <div className="description">Full Stack Developer - Java + Spring + React JS + Java script</div>
                                            </div>
                                            <div className="jd-experience">
                                                <div className="years">3-6 yrs.</div>
                                                <div className="label">{t(`lifeatcentrico.joinus.experience`)}</div>
                                            </div>
                                            <div className="jd-action">
                                                <button className="btn c-button" onClick={applyforjob}>{t(`lifeatcentrico.joinus.applynow`)}</button>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="wrapper">
                                        <div className="job-details">
                                            <div className="jd-info">
                                                <div className="title">Java Full-Stack Developers</div>
                                                <div className="description">Java Enterprise application development – JavaSE / JEE / JSP / Servlet/ JDBC/ Hibernate / EJB3</div>
                                            </div>
                                            <div className="jd-experience">
                                                <div className="years">3-6 yrs.</div>
                                                <div className="label">{t(`lifeatcentrico.joinus.experience`)}</div>
                                            </div>
                                            <div className="jd-action">
                                                <button className="btn c-button" onClick={applyforjob}>{t(`lifeatcentrico.joinus.applynow`)}</button>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6} className="mb-2">
                                    <div className="wrapper">
                                        <div className="job-details">
                                            <div className="jd-info">
                                                <div className="title">Java Backend Developers</div>
                                                <div className="description">OpenAM, OpenDJ, OpenIDM, OpenIG and their extensions with custom Java code Java development in the OpenIDM.</div>
                                            </div>
                                            <div className="jd-experience">
                                                <div className="years">3-6 yrs.</div>
                                                <div className="label">{t(`lifeatcentrico.joinus.experience`)}</div>
                                            </div>
                                            <div className="jd-action">
                                                <button className="btn c-button" onClick={applyforjob}>{t(`lifeatcentrico.joinus.applynow`)}</button>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="wrapper">
                                        <div className="job-details">
                                            <div className="jd-info">
                                                <div className="title">Dot Net Developers</div>
                                                <div className="description">Hands-on in Asp.Net Core, CSharp and Javascript, basic knowledge in Kong Cloud Native APIs, Azure services, Azure Pipelines , RDBMS and Oracle Plsql</div>
                                            </div>
                                            <div className="jd-experience">
                                                <div className="years">3-6 yrs.</div>
                                                <div className="label">{t(`lifeatcentrico.joinus.experience`)}</div>
                                            </div>
                                            <div className="jd-action">
                                                <button className="btn c-button" onClick={applyforjob}>{t(`lifeatcentrico.joinus.applynow`)}</button>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </section>
        </article>
    )
}